import { Indicator, Root } from '@radix-ui/react-checkbox';
import { CheckIcon, MinusIcon } from '@/assets/icons';

import { mergeClasses } from '@/utils';
import { SvgIcon } from '@/components/common';
import { ICheckbox } from './Checkbox.interfaces';

const Checkbox = ({ className, error, ...props }: ICheckbox) => {
  return (
    <div className="inline-flex flex-col">
      <Root
        data-slot="checkbox"
        className={mergeClasses(
          'peer size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50',
          // Normal
          'bg-white border-neutral-n4',
          // Selected
          'data-[state=checked]:bg-brand-primary-base data-[state=checked]:text-white data-[state=checked]:border-brand-primary-base',
          // Disabled
          'disabled:cursor-not-allowed disabled:bg-neutral-n2 disabled:border-neutral-n4',
          // Disabled + Selected
          'disabled:data-[state=checked]:bg-neutral-n2 disabled:data-[state=checked]:border-neutral-n4 disabled:data-[state=checked]:text-neutral-n6',
          // Error
          error && 'bg-white border-semantic-error-base',
          className,
        )}
        {...props}
      >
        <Indicator
          data-slot="checkbox-indicator"
          className="grid place-content-center text-current transition-none"
        >
          <SvgIcon
            component={props.checked === 'indeterminate' ? MinusIcon : CheckIcon}
            className={mergeClasses(
              'w-3.5 h-3.5',
              'data-[state=checked]:text-white',
              'disabled:data-[state=checked]:text-neutral-n6',
            )}
          />
        </Indicator>
      </Root>
      {error && <p className="text-xs text-semantic-error-base">{error}</p>}
    </div>
  );
};

export default Checkbox;
